<template>
  <div
    class="nudge-button"
  >
    <button
      @click="decrementNudgeValue"
    >
      <v-icon>$faMinus</v-icon>
    </button>
    <div>
      {{ value }} {{ label }}
    </div>
    <button
      @click="incrementNudgeValue"
    >
      <v-icon>$faPlus</v-icon>
    </button>
  </div>
</template>

<script>
  export default {
    name: 'NudgeButton',
    props: {
      color: {
        type: String,
        default: 'primary',
      },
      nudge: {
        type: Number,
        default: 5,
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: null,
      },
      label: {
        type: String,
        default: 'NRS',
      },
    },
    data: () => ({
      value: 0,
    }),
    methods: {
      incrementNudgeValue () {
        if (!this.max || this.max > this.value) {
          this.value += this.nudge
          this.$emit('nudge', this.value)
        }
      },
      decrementNudgeValue () {
        if (this.min !== this.value) {
          this.value -= this.nudge
          this.$emit('nudge', this.value)
        }
      },
    },
  }
</script>
<style lang="scss" scoped>
.nudge-button {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  height: 40px;
  padding: 0 12px;
  color: #535353;
  line-height: 20px;
  font-size: 16px !important;
  font-weight: 400;
  background-color: #fff;
  border-radius: 4px;
  letter-spacing: normal;
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
  div {
    min-width: 75px;
    text-align: center;
    padding: 0 12px;
  }
}
</style>
